/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import IframeEmbed from 'bundles/tutorials/components/IframeEmbed';

type Props = {
  src: string;
  title: string;
  description?: string;
};

const styles = {
  wrapper: css`
    margin: 24px 0;

    iframe {
      width: 100%;
      height: 500px;
    }
  `,
};

const CodePen = ({ src, title, description }: Props) => {
  if (!src) {
    return null;
  }

  return (
    <div className="rc-CodePen" css={styles.wrapper}>
      <IframeEmbed src={src} title={title} scrolling="no" frameBorder="no" loading="lazy" allowFullScreen />
      {description && (
        <Typography2 variant="bodySecondary" component="p" color="supportText">
          {description}
        </Typography2>
      )}
    </div>
  );
};

export default CodePen;
